const getSegmentColors = (
  index: number,
  segments: Array<{
    type: 'Feature'
    geometry: {
      type: 'LineString'
      coordinates: Array<Array<number>>
    }
    properties: Record<string, unknown>
  }>,
  hasCurrentSegment: boolean = true
) => {
  const totalSegments = segments.length
  const distanceFromEnd = totalSegments - 1 - index
  const baseColorMap = [
    '#fd7e14', // orange-6 - orange
    '#FFE302', // yellow-6 - yellow
    '#51cf66', // green-6 - green
  ]

  if (!hasCurrentSegment) {
    if (distanceFromEnd === 0) {
      return '#fa5252' // red-6 (acting current)
    }
    // Shift: Treat distanceFromEnd 1 as 0 for the map
    const adjustedDistance = distanceFromEnd - 1
    if (adjustedDistance >= 3) {
      return '#BFEE90'
    }
    return baseColorMap[adjustedDistance]
  }

  if (distanceFromEnd >= 3) {
    return '#BFEE90'
  }

  return baseColorMap[distanceFromEnd]
}

export { getSegmentColors }
